// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3I9G9","container":"styles_container__1A1DK","title":"styles_title__189Vf","wrapper":"styles_wrapper__1h1_X","answer":"styles_answer__nOFoA"};